/**
 * The layout's main content region — `AppLayout` marks its `<main>` with
 * `data-main-content` and makes it programmatically focusable.
 */
const mainContentSelector = "main[data-main-content]";

/**
 * Hands keyboard focus to the page content. Use it after navigating away from
 * a surface that owns focus (e.g. the search modal, where react-aria would
 * otherwise restore focus to the nav trigger the user has just left behind).
 * No-op when the layout isn't mounted.
 */
export function focusMainContent(): void {
  const mainContent = document.querySelector<HTMLElement>(mainContentSelector);
  // The region scrolls, so don't let focusing it move the scroll position that
  // `useNavigationScroll` just restored.
  mainContent?.focus({ preventScroll: true });
}
